export const styles = {
  pageContent: 'tw-flex tw-flex-col tw-gap-2 tw-h-full tw-min-h-0',
};
